const base64js = require('base64-js');
import Validator from 'validatorjs';

/* @ngInject */
export default class AuditorsDashboardCtrl {
	constructor($scope, $rootScope, $timeout, AuditorsDashboardService, NotificationService, LocalStorageService) {
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.LocalStorageService = LocalStorageService;
		this.NotificationService = NotificationService;
		this.AuditorsDashboardService = AuditorsDashboardService;

		this.init();
		this.loadDashboard();
		this._registerEventHandler();
        this.activate();
	}

	init() {
		this.isBusy = false;
		this.howToGuideLink;
		this.auditsToken = {};
		this.auditorSchemes = [];
		this.auditorName = {};
		this.openAuditorSchemeInfo = {};
		this.newAuditDetailsToken = {};



		var urlToken = window.location.search;
		const myArray = urlToken.split("=");
		var auditsToken = myArray[1];
		this.auditsToken = auditsToken;
		console.log(auditsToken);

	}

	_registerEventHandler() {
		
	}

	activate() {
		this.howToGuideLink = `${PretorCDNAddress}${PretorCDNAddress.endsWith('/')
			? ''
            : '/'}docs/Audits How-To-Guide.pdf`;
    }

    _switchIsBusy(flag) {
		this.$timeout(() => {
			this.isBusy = flag;
		});
	}

	loadDashboard() {
		this._switchIsBusy(true);
		this.GetAuditorSchemeInformation();
	}

	async GetAuditorSchemeInformation() {
		var auditsData = await this.AuditorsDashboardService.GetAuditorSchemes(this.auditsToken); //b7ae2fb6-444d-4ecc-b2a7-d29a4434bcdf



		auditsData.Data.forEach(function (searchResult) {

			var monthNames = [
				"January", "February", "March", "April", "May", "June",
				"July", "August", "September", "October", "November", "December"
			];




			var dateChange = searchResult.EndOfFinancialYear.substring(0, 10);
			console.log(dateChange);
			// Convert input string to Date object
			var inputDate = new Date(dateChange);
			console.log(inputDate);


			// Get the day, month, and year
			var day = inputDate.getDate();
			var monthIndex = inputDate.getMonth();
			var year = inputDate.getFullYear();

			


			// Format the Date object to a more readable format
			var parsedDate = day + ' ' + monthNames[monthIndex] + ' ' + year;
			console.log(parsedDate);

			searchResult.EndOfFinancialYear = parsedDate;


		});


		if (auditsData.WasSuccessful == true) {
			this._switchIsBusy(false);

		}
		var auditorHeaderId = auditsData.Data[0].AuditorHeaderId;
		var auditorInfo = await this.AuditorsDashboardService.getAuditorByAuditorHeaderId(auditorHeaderId);
		console.log(auditorInfo);
		this.auditorName = auditorInfo.Auditor;
		this.auditorSchemes = auditsData.Data;
		console.log(this.auditorSchemes);
		$('#auditsSchemesTbl').prop('hidden', false);
	}

	async showSchemeAuditsInfo(FinancialPeriodHeaderId, DB_Ref) {
		var auditTokenDetailsToOpen = await this.AuditorsDashboardService.GetAuditDetailsToView(FinancialPeriodHeaderId, DB_Ref);
		this.newAuditDetailsToken = auditTokenDetailsToOpen.Data[0].Token;
		var openAuditDetailsResult = await this.AuditorsDashboardService.openAuditsDetails(this.newAuditDetailsToken);
    }

	async GetAuditorDashboardToExcel() {
		var excelDocument = await this.AuditorsDashboardService.GetAuditorDashboardToExcel(this.AuditorsDashboardService.auditorHeaderDetails.Id);
		const worksheet = XLSX.utils.json_to_sheet(excelDocument);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "Dashboard Summary");

		/* fix headers */
		XLSX.utils.sheet_add_aoa(worksheet, [["QueryNumber", "DateLogged", "WhoLogged", "BuildingName", "Pretor ID", "Message", "Assignee", "Query Subject", "Status"]], { origin: "A1" });

		/* calculate column width */
		var wscols = [
			{ width: 15 },  // first column
			{ width: 20 }, // second column
			{ width: 16 },
			{ width: 43 },
			{ width: 38 },
			{ width: 50 },
			{ width: 17 },
			{ width: 30 },
			{ width: 15 }
		];
		worksheet["!cols"] = wscols;
		worksheet['!cols'][4] = { hidden: true };
		XLSX.writeFile(workbook, "DashboardSummary.xlsx");
	}
}
